module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tofu-button-component",
    class: {
      'button-active': _vm.isActive
    },
    on: {
      "click": _vm.toggle
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.label) ? _c('span', {
    staticClass: "button-label",
    style: ({
      padding: _vm.$slots.default ?
        (_vm.$slots.tail ? '5px 0' : '5px 8px 5px 0') :
        (_vm.$slots.tail ? '5px 0px 5px 8px' : '5px 8px')
    })
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._t("tail")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1018022e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tofu-button/src/button.vue
// module id = 610
// module chunks = 0